import { Button, Stack, styled, Typography } from "~/common/mui";
import { ACTIVE_QUOTE_PAGE, FREE_CAPACITY_COCKPIT, QUOTE_CONFIRMATION_PAGE } from "~/utils/url/staticUrls";
import { Trans, useTranslation } from "react-i18next";
import { FccAction, trackFccAction } from "~/features/freeCapacityPush/api/trackFccAction";
import { C_ON_TERTIARY_CONTAINER, C_TERTIARY_CONTAINER } from "~/common/components/icon/Colors";

const Root = styled("div")(({ theme }) => ({
  "--column-amount": 4,
  "--fluid-container-margin": "16px",
  display: "grid",
  gridTemplateColumns:
    "calc(var(--fluid-container-margin) - var(--gutter)) repeat(var(--column-amount), minmax(0, 1fr)) calc(var(--fluid-container-margin) - var(--gutter))",
  columnGap: "var(--gutter)",
  background: C_TERTIARY_CONTAINER,
  color: C_ON_TERTIARY_CONTAINER,
  paddingTop: theme.spacing(2),
  paddingBottom: theme.spacing(2),
  placeItems: "center",
  [theme.breakpoints.up("tablet")]: {
    "--column-amount": 6,
    "--fluid-container-margin": "24px",
  },
  [theme.breakpoints.up("desktop-s")]: {
    gridTemplateColumns: "1fr repeat(var(--column-amount), var(--column-width)) 1fr",
    "--column-amount": 12,
    "--column-width": "80px",
  },
  [theme.breakpoints.up("desktop-m")]: {
    "--column-width": "102px",
  },
  [theme.breakpoints.up("desktop-l")]: {
    "--column-width": "120px",
  },
  "> *": {
    gridColumn: "2 / -2",
    placeItems: "center",
  },
}));

export const FCCBanner = () => {
  const { t } = useTranslation();
  return (
    <Root>
      <Stack gap={3} direction={"row"}>
        <Typography color={"inherit"} variant={"titleMedium"}>
          <Trans i18nKey={"page.fcc.banner.label"} />
        </Typography>
        <Button size={"medium"} href={FREE_CAPACITY_COCKPIT} onClick={() => trackFccAction(FccAction.BannerClick)}>
          {t("page.fcc.banner.button")}
        </Button>
      </Stack>
    </Root>
  );
};

const DISABLED_PAGES = [ACTIVE_QUOTE_PAGE, QUOTE_CONFIRMATION_PAGE, FREE_CAPACITY_COCKPIT];

export const isFCCBannerVisible = () => {
  if (!window.SCHA.config.fccShowBannerEnabled) {
    return false;
  }

  const pathname = window.location.pathname;
  if (DISABLED_PAGES.some((page) => pathname.endsWith(page))) {
    return false;
  }
  return true;
};
